<template>
  <div
    id="loadingModal"
    class="modal"
    style="display: block; background-color: rgba(0, 0, 0, 0.15)"
    tabindex="-1"
    aria-hidden="true"
    data-bs-keyboard="false"
    data-bs-backdrop="static"
  >
    <div class="modal-dialog modal-dialog-centered d-flex justify-content-center">
      <div class="modal-content" style="width: 60%">
        <div class="modal-body text-center" style="padding: 32px 24px">
          <div
            class="spinner-border color-main"
            output="status"
            style="height: 5em; width: 5em; --bs-spinner-border-width: 0.5em"
          >
            <span class="visually-hidden">Loading...</span>
          </div>
          <p style="margin: 32px 0 0 0; font-size: 18px">Loading...</p>
        </div>
      </div>
    </div>
  </div>
</template>
